import { SpecializationDto } from "@apiModels/SpecializationDto.csharp";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { useEffect, useState } from "react";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { ServiceDto } from "@apiModels/ServiceDto.csharp";

export const useFilteredSpecializations = (
  specializations: SpecializationDto[],
  services: ServiceDto[],
  location: LocationDto,
  doctor: DoctorDto
) => {
  const [filteredItems, setFilteredItems] = useState<SpecializationDto[]>([]);
  const [otherItems, setOtherItems] = useState<SpecializationDto[]>([]);
  useEffect(() => {
    let filteredSpecializations = [...specializations];

    if (location.id && location.id != "-1") {
      filteredSpecializations = filteredSpecializations.filter((value) =>
        location.specializations.includes(value.id)
      );
    }

    if (doctor.id && doctor.id != "-1") {
      filteredSpecializations = filteredSpecializations.filter((spec) =>
        services.some(
          (service) =>
            service.specializationId == spec.id &&
            doctor.services.includes(service.id) &&
            !service.disableDoctorPageListing
        )
      );

      if (filteredSpecializations.length > 1) {
        filteredSpecializations.sort((a, b) => {
          const indexOfFirst = doctor.relatedSpecializations.indexOf(a.id);
          const indexOfSecond = doctor.relatedSpecializations.indexOf(b.id);

          return indexOfFirst - indexOfSecond;
        });
      }
    }

    setFilteredItems(filteredSpecializations);
    setOtherItems(
      specializations.filter((s) => filteredSpecializations.indexOf(s) == -1)
    );
  }, [location, doctor]);

  return {
    filteredSpecializations: filteredItems,
    unavailableSpecializations: otherItems,
  };
};
